<template>
  <div id="app">
    <div class="container">
      <b-navbar toggleable="lg" type="dark">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="mx-auto">
            <b-nav-item><router-link to="/">Главная</router-link></b-nav-item>
            <b-nav-item><router-link to="/ekran">Выходные сведения</router-link></b-nav-item>
            <b-nav-item><router-link to="/drafters">От&nbsp;составителя</router-link></b-nav-item>
            <b-nav-item><router-link to="/about/default"
                :class="/указатель/.test($route.name) ? 'router-link-exact-active router-link-active' : ''">Библиографический
                указатель</router-link></b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

    </div>
    <router-view />
    <footerComponent />
  </div>
</template>
<script>
import footerComponent from '@/components/footerComponent.vue'

export default {
  components: {
    footerComponent
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler(newName) {
        document.title = newName + ' | Публикации сотрудников Национальной библиотеки УР' || 'Публикации сотрудников Национальной библиотеки УР';
      }
    }
  },
  data() {
    return {

      properties: [
        ['f200', 'sA'],
        ['f200', 'sE'],
        // ['f200', 'sF'],
        ['f463', 'sC'],
        ['f963', 'sE'],
        ['f963', 'sF'],
        ['f331', '']
      ]
    }
  },
  mounted() {
    this.loadIrbis();
    this.getHeader();
  },
  methods: {
    getHeader() {

    },
    loadIrbis() {
      if (this.$store.getters.IRBIS === null) {
        this.axios.get( window.location.origin + "/publib/data.json").then(
        // this.axios.get(window.location.origin + "/data.json").then(
          (response) =>
          (this.$store.commit('irbisSet', this.removeEmpty(response.data.collection.record))
            // , console.log(response)
          )
        );
      }
    },
    removeEmpty(arr) {
      let familyArr = [];
      let publicationsArr = [];
      for (let i = arr.length - 1; i >= 0; i--) {
        if (arr[i].f690 === undefined) {
          arr.splice(i, 1);
        } else if (arr[i].f700.sA !== undefined) {
          familyArr.push(arr[i].f700.sA);
          if (arr[i].f463.sC !== undefined) {
            publicationsArr.push(this.removeQuot(arr[i].f463.sC));
          }
        }
      }
      familyArr = familyArr.filter((item, index) => {
        return familyArr.indexOf(item) === index
      });

      this.$store.commit('familySortedSet', familyArr
        // .map(subArray => subArray[0])
        .sort((a, b) => a.localeCompare(b)));


      this.$store.commit('publicationsSet', publicationsArr.filter((item, index) => {
        return publicationsArr.indexOf(item) === index
      }).sort((a, b) => a.localeCompare(b)));

      //this.shuffle(familyArr);
      // console.log(publicationsArr);
      // let tmpArr2 = new Set(tmpArr);
      //this.replaceWordWithAlternatives(arr, '&quot;', '«', '»');
      this.typograph(arr);



      this.$store.commit('familySet', this.addRandomToArr(this.shuffle(familyArr)));


      // console.log('commit familySet');
      // this.familyList = tmpArr2;
      // this.addRandomToArr();
      // return arr;
      return arr.slice().sort(function (a, b) {
        if (a.f700 !== undefined && b.f700 !== undefined)
          return (a.f700.sA > b.f700.sA) ? 1 : -1;
        else if ((a.f700 === undefined && b.f700 !== undefined))
          return (a.f200.sA > b.f700.sA) ? 1 : -1;
        else if ((a.f700 !== undefined && b.f700 === undefined))
          return (a.f700.sA > b.f200.sA) ? 1 : -1;
        else if ((a.f700 === undefined && b.f700 === undefined))
          return (a.f200.sA > b.f200.sA) ? 1 : -1;
      });
    },
    typograph(arr) {
      for (let j = 0; j < arr.length; j++) {

        for (let i = 0; i < this.properties.length; i++) {
          if (arr[j][this.properties[i][0]] != undefined && arr[j][this.properties[i][0]][this.properties[i][1]] != undefined) {
            arr[j][this.properties[i][0]][this.properties[i][1]] = this.getSouz(arr[j][this.properties[i][0]][this.properties[i][1]], this.properties[i]);
          }
          if (arr[j][this.properties[i][0]] != undefined && this.properties[i][1] == '') {
            //console.log(11111111);
            arr[j][this.properties[i][0]] = this.getSouz(arr[j][this.properties[i][0]], this.properties[i]);
          }
        }
        // f200.sA
        // f200.sE
        // f200.sF
        // f463.sC
        // f963.sE
        // f963.sF
        // f331



      }

    },
    removeQuot(text) {
      const lapkiPattern = /(?<startlapki>"|&quot;)(?<text>[—―/–\\-‑=a-zA-Zа-яёА-ЯЁ0-9ӞӦӜӤӴӟӧӝӥӵ№ .,&;:!()[\]]+)(?<endlapki>"|&quot;)/g;
      const tireLongPattern = /(?<startspace> )(?<tire>—|―|-|-|–|‑|–)(?<endspace> )/g;
      text = text.replace(tireLongPattern, " —$<endspace>");
      return text.replace(lapkiPattern, "«$<text>»");
    },
    getSouz(text, properties) {
      const souzPattern = /(?<startspace> |\(|«|\[)(?<souz>[0-9а-яёА-ЯЁӞӦӜӤӴa-zA-Zӟӧӝӥӵ]{1,2})(?<endspace> )/g;
      const souzPattern1 = /(?<startspace>&nbsp;)(?<souz>[0-9а-яёА-ЯЁӞӦӜӤӴa-zA-Zӟӧӝӥӵ]{1,2})(?<endspace> )/g;
      const souzPattern2 = /(?<startspace> )(?<souz>[0-9а-яёА-ЯЁӞӦӜӤӴa-zA-Zӟӧӝӥӵ]{1,2})(?<tochka>[.,:;]{1,2})*(?<endspace> )/g;
      const iofPattern = /(?<![,.])(?<startspace>\s|&nbsp;|(?:^))(?<name>[А-ЯЁӞӦӜӤӴA-Z]\.)(&nbsp;|\s)(?<lastname>[А-ЯЁӞӦӜӤӴA-Z]\.)*(&nbsp;|\s)*(?<family>[А-ЯЁӞӦӜӤӴA-Z][а-яёӟӧӝӥӵa-z]+)/g;
      const znakiPattern = /(?<startspace> )(?<znak>:|;|\/|\/\/|–)(?<endspace> )/g;
      const numberLettersPattern = /(?<number>[0-9]+)(?<defis>-|‑)(?<letters>[a-zа-яёӟӧӝӥӵ]+)/g;
      const tireLongPattern = /(?<startspace> )(?<tire>—|―|-|-|–|‑|–)(?<endspace> )/g;
      const ggPattern = /(?<number>\d+)(?<startspace> )(?<gg>[г.]{1,3})/g;
      const ggOkonchaniePattern = /(?<number>\d+)(?<prirachenie>—|―|-|-|–|‑|–)(?<okonchanie>[а-яё]{1,2})(?<startspace> |&nbsp;)(?<gg>[г.]{1,3})/g;
      const cityPattern = /((?<!\d))(?<startspace> |)(?<gg>[г]+\.)(?<endspace> )(?<letter>[A-ZА-ЯЁӞӦӜӤӴ])/g;
      const datePattern2 = /(?<firstnumber>[0-9]{1,2})(?<defis>—|―|-|-|–|‑|–)(?<secondnumber>[0-9]{1,2})(?<space> )(?<month>января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря)/g;
      const datePattern1 = /(?<secondnumber>[0-9]{1,2})(?<space> )(?<month>января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря)/g;
      const lapkiPattern = /(?<startlapki>"|&quot;)(?<text>[—―/–\\-‑=a-zA-Zа-яёА-ЯЁ0-9ӞӦӜӤӴӟӧӝӥӵ№ .,&;:!()[\]]+)(?<endlapki>"|&quot;)/g;
      text = text.replace(lapkiPattern, "«$<text>»");
      text = text.replace(ggOkonchaniePattern, "$<number>&#8209;$<okonchanie>&nbsp;$<gg>");
      text = text.replace(cityPattern, "$<startspace>$<gg>&nbsp;$<letter>");
      text = text.replace(tireLongPattern, "&nbsp;—$<endspace>");
      text = text.replace(souzPattern, "$<startspace>$<souz>&nbsp;");
      text = text.replace(souzPattern1, "$<startspace>$<souz>&nbsp;");
      text = text.replace(souzPattern2, "&nbsp;$<souz>$<tochka>$<endspace>");
      text = text.replace(znakiPattern, "&nbsp;$<znak>$<endspace>");
      text = text.replace(numberLettersPattern, "$<number>&#8209;$<letters>");

      text = text.replace(ggPattern, "$<number>&nbsp;$<gg>");


      text = text.replace(datePattern2, "$<firstnumber>–$<secondnumber>&nbsp;$<month>");
      text = text.replace(datePattern1, "<secondnumber>&nbsp;$<month>");
      if (properties[0] !== 'f963' && properties[0] !== 'sF') {
        text = text.replace(iofPattern, " $<name>&nbsp;$<lastname>&nbsp;$<family>");
      }
      return text;
      // return text;
    },
    shuffle(arr) {
      const arrCopy = arr.slice();
      let currentIndex = arrCopy.length;

      while (currentIndex !== 0) {
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // Меняем местами элементы в копии массива
        [arrCopy[currentIndex], arrCopy[randomIndex]] = [arrCopy[randomIndex], arrCopy[currentIndex]];
      }
      return arrCopy;
    },
    getRandomInt(min, max) {
      return Math.round(Math.random() * (max - min) + min);
    },
    toHex(c) {
      var hex = c.toString(16);
      return hex.length == 1 ? "0" + hex : hex;
    },
    colorRand() {
      return "#" + this.toHex(this.getRandomInt(120, 255)) + this.toHex(this.getRandomInt(120, 255)) + this.toHex(this.getRandomInt(120, 255));
      // return '#' + (Math.floor(Math.random() * (6710886 - 2236962 + 1) + 2236962)).toString(16);
      // return '#' + (Math.floor(Math.random() * (16777215 - 1048576 + 1) + 1048576)).toString(16);
    },
    colorRandLight() {
      return "#" + this.toHex(this.getRandomInt(210, 255)) + this.toHex(this.getRandomInt(210, 255)) + this.toHex(this.getRandomInt(210, 255));
      // return '#' + (Math.floor(Math.random() * (6710886 - 2236962 + 1) + 2236962)).toString(16);
      // return '#' + (Math.floor(Math.random() * (16777215 - 1048576 + 1) + 1048576)).toString(16);
    },
    addRandomToArr(arr) {
      let tmpArr = [];
      // console.log(this.familyList.length);
      for (let i = 0; i < arr.length; i++) {
        // console.log(111);
        // arr[i] = [arr[i], this.getRandomInt(18, 30), this.colorRand()];
        // tmpArr.push([arr[i], this.getRandomInt(12, 23), this.colorRand()]);
        tmpArr.push([arr[i], (22 - arr[i].length) * 1.6, this.colorRand()]);
        // console.log(this.familyList[i]);
      }
      tmpArr.splice(10, 0, ["Публикации", 40, this.colorRandLight(), 1]);
      tmpArr.splice(17, 0, ["сотрудников", 40, this.colorRandLight(), 1]);
      tmpArr.splice(27, 0, ["Национальной", 40, this.colorRandLight(), 1]);
      tmpArr.splice(37, 0, ["библиотеки", 40, this.colorRandLight(), 1]);
      tmpArr.splice(47, 0, ["Удмуртской", 40, this.colorRandLight(), 1]);
      tmpArr.splice(56, 0, ["Республики", 40, this.colorRandLight(), 1]);
      // console.log('addRandomToArr(arr)');
      return tmpArr;
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'Philosopher';
  src: url('~@/assets/fonts/Philosopher-Italic.woff2') format('woff2'),
    url('~@/assets/fonts/Philosopher-Italic.woff') format('woff');
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'Philosopher';
  src: url('~@/assets/fonts/Philosopher-Bold.woff2') format('woff2'),
    url('~@/assets/fonts/Philosopher-Bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Philosopher';
  src: url('~@/assets/fonts/Philosopher-BoldItalic.woff2') format('woff2'),
    url('~@/assets/fonts/Philosopher-BoldItalic.woff') format('woff');
  font-weight: bold;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'Philosopher';
  src: url('~@/assets/fonts/Philosopher-Regular.woff2') format('woff2'),
    url('~@/assets/fonts/Philosopher-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

#app {
  /* font-family: 'Philosopher'; */
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #d4d4d4;
  background-color: black;
  background-image: url('~@/assets/bg.svg');
  background-size: cover;
  background-attachment: fixed;
  background-position: center center;
  background-repeat: no-repeat;
  font-size: 20px;
  min-height: 100vh;
  font-weight: 300;
}

html {
  background-color: black;
}

select {
  color: #ffffff;
  background-color: #1b1a36;
  border: 1px solid #fff7d581;
}

input::-moz-placeholder {
  color: rgb(186, 186, 186);
}

input::-webkit-input-placeholder {
  color: rgb(186, 186, 186);
}

input {
  color: #ffffff;
  background-color: #1b1a36;
  border: 1px solid #fff7d581;
}

nav {
  padding: 30px;
}

nav a {
  /* font-weight: bold; */
  color: #fff7d5;
  text-decoration: none;
  font-family: 'Philosopher';
}

nav a:hover {
  color: #f0d24e;
}

nav a.router-link-exact-active {
  color: #fffc9b;
}

/* СКРОЛЛБАР */

::-webkit-scrollbar-track {
  background-color: #32312e;
  box-shadow: 0 0 3px #000 inset;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 5px;
  border-radius: 8px;
  background-color: #7b7e87;
  box-shadow: 0 1px 1px #000 inset;
  background-position: center;
  background-repeat: no-repeat;
}

::-webkit-scrollbar {
  width: 16px;
}

.fio-titul h1 {
  font-family: 'Philosopher';
  font-weight: normal;
  font-style: normal;
  font-size: calc((100vw - 480px)/(1280 - 480) * (60 - 30) + 30px);
  text-align: left;
  left: 0;
}

.fio-titul h3 {
  font-family: 'Philosopher';
  font-weight: normal;
  font-style: normal;
  font-size: calc((100vw - 480px)/(1280 - 480) * (30 - 15) + 15px);
  text-align: left;
  left: 0;
}

.fio-titul {
  background: linear-gradient(to top right, var(--bgColor5) 0%, var(--bgColor6) 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: table;
}

p {
  text-align: left;
  font-size: 20px;
  /* color: black; */
}
</style>
